import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Order, SalesOrdersService } from '@vendasta/sales-orders';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sales-ui-sales-order-details-customer-notes',
  templateUrl: './sales-order-details-customer-notes.component.html',
  styleUrls: ['./sales-order-details-customer-notes.component.scss', '../sales-order-details-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SalesOrderDetailsCustomerNotesComponent implements OnInit, OnChanges {
  @Input() order: Order;
  @Input() isCustomerDetails: boolean;
  @Input() editable = true;

  isEditing = false;
  customerNotes: string;
  updatingNotes = false;

  constructor(
    private readonly salesOrdersService: SalesOrdersService,
    private readonly alertService: SnackbarService,
    private cdk: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.customerNotes = changes.customerNotes ? changes.customerNotes.currentValue : this.customerNotes;
  }

  ngOnInit(): void {
    this.customerNotes = this.order.customerNotes;
  }

  edit(): void {
    this.isEditing = true;
  }

  updateCustomerNotes(): void {
    this.isEditing = true;
    this.updatingNotes = true;
    this.salesOrdersService
      .updateCustomerNotes(this.order.orderId, this.order.businessId, this.customerNotes)
      .pipe(take(1))
      .subscribe(
        () => {
          this.isEditing = false;
          this.updatingNotes = false;
          this.cdk.detectChanges();
        },
        () => {
          this.isEditing = false;
          this.updatingNotes = false;
          this.customerNotes = this.order.customerNotes;
          this.cdk.detectChanges();
          this.alertService.openErrorSnack('FRONTEND.SALES_UI.CUSTOMER_NOTES_ERROR');
        },
      );
  }
}
